import axios from 'axios';

const token = localStorage.getItem('accessToken');

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: { 'Authorization': `bearer ${token}` }
});

export default api;